import { render, staticRenderFns } from "./addServicio.vue?vue&type=template&id=021956fa&scoped=true&"
import script from "./addServicio.vue?vue&type=script&lang=js&"
export * from "./addServicio.vue?vue&type=script&lang=js&"
import style0 from "./addServicio.vue?vue&type=style&index=0&id=021956fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021956fa",
  null
  
)

export default component.exports